import React from 'react'

function MenuBtDivider() {
    return (
        <div style={{height: '80%', width: '1px', borderRight: '1px solid #c2c2c7', top: '10%', position: 'relative'}}></div>     
    )
}

export default MenuBtDivider 
  